$(document).ready(function () {
    // The DSN used to be hardcoded here, which meant every browser error from
    // any deployment was reported into one fixed Sentry project. It now comes
    // from SENTRY_DSN_CLIENT via the layout, and front-end reporting simply
    // stays off when that is unset (the SDK is not even loaded then).
    var dsn = window.__SENTRY_DSN__

    if (!dsn || typeof Sentry === 'undefined') {
        return
    }

    Sentry.init({
        dsn: dsn,
        environment: window.__SENTRY_ENV__ || 'production',
    })
})
